import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADDRESS, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const CountryList = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'id', filterType: FilterType.string, show: false },
			{ Header: 'name', accessor: 'name', filterType: FilterType.string, showOnMobile: true },
			{ Header: 'countryCode', accessor: 'shortCode', filterType: FilterType.string, showOnMobile: true },
			{
				Header: 'hasState',
				accessor: 'hasState',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 100
			},
			{
				Header: 'hasNeighbourhood',
				accessor: 'hasNeighbourhood',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 100
			},
			{
				Header: 'hasShortAddress',
				accessor: 'hasShortAddress',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 100
			},
			{
				Header: 'zipCodeRequired',
				accessor: 'zipCodeRequired',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 100
			},
			{
				Header: 'allowStateCustomValue',
				accessor: 'allowStateCustomValue',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 100
			},
			{
				Header: 'allowCityCustomValue',
				accessor: 'allowCityCustomValue',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 100
			},
			{
				Header: 'allowDistrictCustomValue',
				accessor: 'allowDistrictCustomValue',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 100
			},
			{
				Header: 'internationalDocRequirement',
				accessor: 'internationalDocRequirement',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 100
			},
			{
				Header: 'useComplexCityComponent',
				accessor: 'useComplexCityComponent',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				width: 100
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.COUNTRIES}
				columns={columns}
				fetchUrl={ADDRESS.GET_COUNTRIES_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.SUPPORT}
				exportName="countries"
			/>
		</TabTableContainer>
	);
};

export default CountryList;
